import { Address as PBAddress } from "gen/proto/address/models_pb"
import { Address } from "shared-ts/libs/address"

import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type AddressAccessorFn<T> = TypedAccessor<T, PBAddress | undefined>
type AddressColumn<T> = Omit<DataColumn<T>, "type" | "renderCell" | "width">
export type AddressColumnHelper<T> = (
  accessorFn: AddressAccessorFn<T>,
  col: AddressColumn<T>
) => DataColumn<T>

export function address<T>(
  accessorFn: AddressAccessorFn<T>,
  col: AddressColumn<T>
): DataColumn<T> {
  return data({
    renderCell: (rowData) => {
      const value = accessorFn(rowData)
      if (!value) return null
      return Address.fromPB(value).format
    },
    width: TableCellWidth.ExtraExtraExtraLarge,
    ...col,
  })
}
